import { Link } from 'react-router-dom';
import { articles } from '@/mocks/siteData';

export default function ArticlesPreview() {
  return (
    <section className="w-full py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between mb-10 gap-4">
            <div>
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
                最新体育资讯
              </h2>
              <p className="text-foreground-500 text-sm md:text-base">
                赛事分析、投注指南、行业动态，一手掌握
              </p>
            </div>
            <Link
              to="/article/app-download-guide"
              className="inline-flex items-center gap-1.5 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors whitespace-nowrap"
            >
              查看全部文章
              <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
            </Link>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
            {articles.slice(0, 6).map((article) => (
              <Link
                key={article.slug}
                to={`/article/${article.slug}`}
                className="group block rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200/60 bg-background-50 transition-all duration-300 no-underline"
              >
                <div className="relative h-44 overflow-hidden">
                  <img
                    src={article.image}
                    alt={article.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                  {article.featured && (
                    <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-accent-500 text-foreground-950 text-xs font-medium">
                      推荐
                    </span>
                  )}
                </div>
                <div className="p-5">
                  <div className="flex items-center gap-3 mb-3 text-xs text-foreground-400 flex-wrap">
                    <span className="px-2 py-0.5 rounded bg-secondary-100 text-secondary-700 font-medium">
                      {article.category}
                    </span>
                    <span>{article.date}</span>
                    <span className="flex items-center gap-1">
                      <i className="ri-time-line w-3 h-3 flex items-center justify-center"></i>
                      {article.readTime}
                    </span>
                  </div>
                  <h3 className="font-semibold text-foreground-900 text-sm md:text-base mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                    {article.title}
                  </h3>
                  <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">
                    {article.excerpt}
                  </p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}